export type LinkPreviewImage = {
  url: string
  width?: number
  height?: number
}

export type LinkPreviewData = {
  url: string
  title?: string
  siteName?: string
  description?: string
  images?: LinkPreviewImage[]
  favicons?: string[]
  mediaType?: 'text' | 'image' | 'audio' | 'video' | 'application' | 'other'
  contentType?: string
}
